import request from '@/api/http.js'


export function zones(data) {
    return request({
        url: 'zones',
        method: 'get',
        params: data,
    })
}
export function zone(data) {
    return request({
        url: 'zone',
        method: 'get',
        params: data,
    })
}
export function postTableProfile(data) {
    return request({
        url: 'zone/TableProfile',
        method: 'post',
        data,
    })
}

export function getZoneTableProfile(data) {
    return request({ 
        url: 'zone/TableProfile',
        method: 'get',
        params: data,
    })
}
//获取已使用的tc列表
export function tcUserProfileList(data) {
    return request({
        url: 'zone/tcProfile',
        method: 'get',
        params: data,
    })
}
//使用tc
export function tcUserProfile(data) {
    return request({
        url: 'zone/tcProfile',
        method: 'post',
        data,
    })
}
//查询已定义的配置
export function getTableProfile(data) {
    return request({
        url: 'TableProfile',
        method: 'get',
        params: data,
    })
}
export function postGksj(data) {
    return request({
        url: 'zone/gksj',
        method: 'post',
        data,
    })
}

export function getGksj(data) {
    return request({
        url: 'zone/gksj',
        method: 'get',
        params: data,
    })
}

export function postImportingProfile(data) {
    return request({
        url: 'zone/ImportingProfile',
        method: 'post',
        data,
    })
}

export function getImportingProfile(data) {
    return request({
        url: 'zone/ImportingProfile',
        method: 'get',
        params: data,
    })
}

export function postPasswordStrategy(data) {
    return request({
        url: 'zone/passwordStrategy',
        method: 'post',
        data,
    })
}

export function getPasswordStrategy(data) {
    return request({
        url: 'zone/passwordStrategy',
        method: 'get',
        params: data,
    })
}

export function postBdata(data) {
    return request({
        url: 'zone/bdata',
        method: 'post',
        data,
    })
}

export function getBdata(data) {
    return request({
        url: 'zone/bdata',
        method: 'get',
        params: data,
    })
}

export function inherit(data) {
    return request({
        url: 'zone/inherit',
        method: 'post',
        data,
    })
}

export function edit(data) {
    return request({
        url: 'zone/edit',
        method: 'post',
        data,
    })
}

export function remove(data) {
    return request({
        url: 'zone/delete',
        method: 'post',
        data,
    })
}

export function getPdfCarryJxwj(data) {
    return request({
        url: 'zone/pdfCarryJxwj',
        method: 'get',
        data,
    })
}

export function postPdfCarryJxwj(data) {
    return request({
        url: 'zone/pdfCarryJxwj',
        method: 'post',
        data,
    })
}

export function getPdfFileNameProfile(data) {
    return request({
        url: 'zone/pdfFileNameProfile',
        method: 'get',
        data,
    })
}

export function postPdfFileNameProfile(data) {
    return request({
        url: 'zone/pdfFileNameProfile',
        method: 'post',
        data,
    })
}

export function getCustomPdf(data) {
    return request({
        url: 'zone/customPdf',
        method: 'get',
        data,
    })
}

export function postCustomPdf(data) {
    return request({
        url: 'zone/customPdf',
        method: 'post',
        data,
    })
}
//配置pdf时间
export function reBuildPdfProfile(data) {
    return request({
        url: 'zone/rebuildPdfProfile',
        method: 'post',
        data,
    })
}
//获取配置pdf时间
export function getPdfProfile(data) {
    return request({
        url: 'zone/rebuildPdfProfile',
        method: 'get',
        data,
    })
}
//获取cms配置
export function getCmsProfile(data) {
    return request({
        url: 'zone/cmsProfile',
        method: 'get',
        params: data,
    })
}
//cms配置
export function postCmsProfile(data) {
    return request({
        url: 'zone/cmsProfile',
        method: 'post',
        data,
    })
}
//判断用户是否可以修改公开表
export function getMutateTableProfile(data) {
    return request({
        url: 'zone/MutateTableProfile',
        method: 'get',
        params: data,
    })
}
//配置用户是否可以修改公开表
export function postMutateTableProfile(data) {
    return request({
        url: 'zone/MutateTableProfile',
        method: 'post',
        data,
    })
}

//查看维护状态
export function getMaintain(data) {
    return request({
        url: 'zone/maintain',
        method: 'get',
        params: data,
    })
}

//配置维护状态
export function postMaintain(data) {
    return request({
        url: 'zone/maintain',
        method: 'post',
        data,
    })
}